import { Link } from 'react-router-dom';
import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function NotFound() {
  return (
    <main className="notfound">
      <div className="shell">
        <p className="kicker">Error 404</p>
        <h1>We could not find that page</h1>
        <p>
          The link may be out of date. Head back to the homepage, or call us and we will point
          you to what you need.
        </p>
        <div className="section__actions">
          <Link to="/" className="btn btn--green">
            Back to homepage
          </Link>
          <a href={SUPPORT_PHONE_TEL} className="btn btn--quiet">
            Call {SUPPORT_PHONE_LABEL}
          </a>
          <button type="button" className="btn btn--quiet" onClick={openZohoChat}>
            Live Chat
          </button>
        </div>
      </div>
    </main>
  );
}
